const EditBranchSkeleton = () => (
    <div className="admin_gold_edit_branch">
      <div className="twgold_skeleton" style={{ height: 28, width: '40%' }} />
      <div className="twgold_skeleton" style={{ height: 44 }} />
      <div className="twgold_skeleton" style={{ height: 44 }} />
      <div className="twgold_skeleton" style={{ height: 44 }} />
      <div className="twgold_skeleton" style={{ height: 42, width: '30%' }} />
    </div>
  );
  
  export default EditBranchSkeleton;
  